export default class Form {
  constructor() {
    this.formSelector = '.js-form';
    this.inputSelectors = ['input', 'textarea', 'select'];
    this.labelSelectors = ['label'];

    this.scopedInputSelectors = this.inputSelectors.map((selector) => `${this.formSelector} ${selector}`).join(', ');
    this.scopedLabelSelectors = this.labelSelectors.map((selector) => `${this.formSelector} ${selector}`).join(', ');

    this.urlParams = new URLSearchParams(new URL(window.location).search);

    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInput = this.handleInput.bind(this);

    this.init();
  }

  init() {
    this.inputs = document.querySelectorAll(this.scopedInputSelectors);
    this.labels = document.querySelectorAll(this.scopedLabelSelectors);

    // For each input, check if it has a value in the URL params to prefill
    this.inputs.forEach((input) => {
      const inputName = input.getAttribute('name');
      if (!inputName) return;
      const inputValue = this.urlParams.get(inputName);
      if (!inputValue) return;
      input.value = inputValue;
    });

    // Filter out inputs that don't have a label based on the for attribute
    const filteredInputs = [];
    const filteredLabels = [];
    this.labels.forEach((label) => {
      if (!label.hasAttribute('for')) return;
      const inputId = label.getAttribute('for');
      const filteredInput = Array.from(this.inputs).find((input) => input.id === inputId);
      if (!filteredInput) return;
      filteredInputs.push(filteredInput);
      filteredLabels.push(label);
    });
    this.inputs = filteredInputs;
    this.labels = filteredLabels;

    this.addEventListeners();
    this.checkInputValues();
  }

  handleFocus(index) {
    const label = this.labels[index];
    if (label) label.classList.add('input-active');
  }

  handleBlur(input, index) {
    if (input.value.trim() === '') {
      const label = this.labels[index];
      if (label) label.classList.remove('input-active');
    }
  }

  handleInput(input, index) {
    const label = this.labels[index];

    if (label) {
      if (input.value.trim() === '') {
        label.classList.remove('input-active');
      } else {
        label.classList.add('input-active');
      }
    }
  }

  addEventListeners() {
    this.inputs.forEach((input, index) => {
      input.addEventListener('focus', () => this.handleFocus(index));
      input.addEventListener('blur', () => this.handleBlur(input, index));
      input.addEventListener('input', () => this.handleInput(input, index));
      input.addEventListener('change', () => this.handleInput(input, index));
    });
  }

  checkInputValues() {
    this.inputs.forEach((input, index) => {
      if (input.value.trim() !== '') {
        const label = this.labels[index];
        if (label) label.classList.add('input-active');
      }
    });
  }

  removeEventListeners() {
    this.inputs.forEach((input, index) => {
      input.removeEventListener('focus', () => this.handleFocus(index));
      input.removeEventListener('blur', () => this.handleBlur(input, index));
      input.removeEventListener('input', () => this.handleInput(input, index));
      input.removeEventListener('change', () => this.handleInput(input, index));
    });
  }

  destroy() {
    this.removeEventListeners();
    this.checkInputValues();

    this.inputs = [];
    this.labels = [];
  }
}



// WEBPACK FOOTER //
// ./scripts/components/form.js